<!-- Note! อ่านก่อนทำ: หน้า package-landing 
     ใช้ร่วมกันทั้ง desktop page และ pricing page 
     ข้อมูล package flowaccount มาจาก db ส่วน payroll, autokey เป็น html แก้ไขได้โดยตรงผ่านตัวแปรภาษา
-->

<div
  class="heading-pricing-container"
  [ngClass]="{ 'heading-margin': page === currentPage.Pricing }"
  (window:resize)="onResize($event)"
>
  <div class="price-head heading-pricing-page">
    <div class="heading-pricing-page__sub-title" [ngClass]="translate.currentLang" [innerHtml]="getDescription()">
    </div>
    <div class="heading-pricing-page__title">{{ getTitle() }}</div>
  </div>

  <div class="switch-tab-container">
    <ng-container
      *ngIf="
        (upgradeType === upgradeTypeEnum.Upgrade ||
          currentPackageDetail == null ||
          currentPackageDetail.periodType !== periodTypeEnum.Year) &&
        isLoading === false
      "
    >
      <div class="switch-tab">
        <div>
          <span class="monthly" [ngClass]="{ 'color-black': periodType === periodTypeEnum.Month }">{{
            'PACKAGE_TABLE.MONTHLY' | translate
          }}</span>
        </div>

        <div class="checkbox-container">
          <input
            id="checkedbox"
            type="checkbox"
            name="checkbox"
            checked="checked"
            aria-label="toggle period"
            [checked]="periodType === periodTypeEnum.Year"
            (click)="
              togglePeriod(periodType === periodTypeEnum.Year ? periodTypeEnum.Month : periodTypeEnum.Year);
              onTrackTogglePeriod()
            "
            class="cm-toggle"
          />
        </div>

        <div class="yearly-text-container">
          <span class="yearly" [ngClass]="{ 'color-blue': periodType === periodTypeEnum.Year }">{{
            'PACKAGE_TABLE.YEARLY' | translate
          }}</span>
        </div>

        <img class="discount-for-desktop" src="{{ displayImageSave(periodType) }}" alt="Yearly discount 17%" />
        <img class="discount-for-mobile" src="{{ displayImageMobileSave(periodType) }}" alt="Yearly discount 17%" />
      </div>
    </ng-container>
  </div>

  <section class="pricing-package-container">
    <!-- 1  get data from api premium, advance  package -->
    <ng-container *ngFor="let package of packageVisible | async">
      <ng-container *ngIf="package">
        <div class="package-box" *ngIf="showPricingPackage(package.level)">
          <ng-container [ngSwitch]="isMostPopularOn">
            <ng-contaner *ngSwitchCase="true">
              <div class="package-recommend" *ngIf="package.level === packageLevelEnum.Pro"> Most Popular </div>
            </ng-contaner>
            <ng-contaner *ngSwitchCase="false">
              <div class="package-recommend" *ngIf="package.level === packageLevelEnum.ProBusiness"> Best Value </div>
            </ng-contaner>
          </ng-container>
          <div class="package-box__top">
            <div class="package-sub-heading" [innerHTML]="displaySubHeading(package.level) | translate"></div>

            <div class="package-name">
              {{ package.nameEN }}
              <ng-container [ngSwitch]="isMostPopularOn">
                <ng-container *ngSwitchCase="true">
                  <span *ngIf="package.level === packageLevelEnum.Pro" class="great-package">{{
                    'PACKAGE_TABLE.RECOMMEND' | translate
                  }}</span>
                </ng-container>
                <ng-container *ngSwitchCase="false">
                  <span *ngIf="package.level === packageLevelEnum.ProBusiness" class="great-package">{{
                    'PACKAGE_TABLE.RECOMMEND' | translate
                  }}</span>
                </ng-container>
              </ng-container>
            </div>
            <div class="package-price">
              <span *ngIf="package.level === packageLevelEnum.ProBusiness" class="start">{{
                'PACKAGE_TABLE.START' | translate
              }}</span>
              <span class="price" [ngClass]="{ 'color-blue': package.price > 0 }">{{
                package.price > 0
                  ? convertPriceYearlyToMonthly(package.price)
                  : ('PACKAGE_TABLE.PACKAGE_BASIC.FREE' | translate)
              }}</span>

              <span class="price-postfix">{{ getPricePostfix(package.price) | translate }}</span>

              <span
                *ngIf="periodType === periodTypeEnum.Year"
                class="price-detail basic"
                [ngClass]="{ basic: package.level === 0 }"
              >
                {{ displayPricePerYear(package.price | number) }}
              </span>
            </div>

            <!-- button -->
            <div class="package-button">
              <ng-container
                *ngTemplateOutlet="packageButton; context: { package: package, button: getButtonClass(package) }"
              >
              </ng-container>
            </div>
          </div>

          <div class="package-box__bottom">
            <div
              *ngIf="page === currentPage.Home"
              class="toggle"
              (click)="onClickToggle(package.level)"
              [ngClass]="{ 'margin-bottom': checkTogglePackageList(package.level) }"
            >
              <span>{{ 'PACKAGE_TABLE.PACKAGE_DETAIL' | translate }}</span>
              <i
                class="fa fa-angle-{{ checkTogglePackageList(package.level) === true ? 'up' : 'down' }}"
                aria-hidden="true"
              ></i>
            </div>
            <!-- desktop -->
            <div class="fa-feature-list  {{ translate.currentLang }}  desktop">
              <div class="product-name">
                <img
                  src="{{ package.application.icon }} "
                  class="fa-logo"
                  loading="lazy"
                  alt="FlowAccount icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> {{ package.application.name }}</span>
              </div>

              <ng-container
                *ngFor="
                  let item of translate.currentLang === 'th' ? package.featureTH.items_1 : package.feature.items_1;
                  let i = index
                "
              >
                <div class="list-text">
                  <!-- dot ถ้าเป็น packgae: free จะมี dot with text ตั้งแต่ index === 0 
                      dot ถ้าเป็น packgae: !== free จะมี dot with text ตั้งแต่ index > 0 
                  -->

                  <span
                    *ngIf="i !== 0 && package.level !== packageLevelEnum.Free && !checkPackageSubList(package.level, i)"
                    class="dot"
                    ><i class="fa fa-check"></i
                  ></span>

                  <!-- sub list dot (only ProBusiness) -->
                  <span
                    *ngIf="i !== 0 && package.level !== packageLevelEnum.Free && checkPackageSubList(package.level, i)"
                    class="dot"
                    ><i class="fa fa-check"></i
                  ></span>

                  <!-- free package -->
                  <span *ngIf="package.level === packageLevelEnum.Free" class="dot"><i class="fa fa-check"></i></span>
                  <!-- text  ถ้าเป็น packgae: !== free index === 0  text จะเป็นตัวหนา -->
                  <span *ngIf="package.level === packageLevelEnum.Free" class="text" [innerHtml]="item"></span>

                  <!-- not free pack in first item -->
                  <span
                    *ngIf="package.level !== packageLevelEnum.Free && !checkPackageSubList(package.level, i)"
                    [ngClass]="{ 'text-bold': i === 0, text: i !== 0 }"
                    [innerHtml]="item"
                  ></span>

                  <!-- text มี sub list (only ProBusiness) -->
                  <span *ngIf="checkPackageSubList(package.level, i)" [innerHtml]="item"></span>
                </div>
              </ng-container>
            </div>

            <div class="mobilepos-feature-list desktop">
              <div class="product-name">
                <picture>
                  <source srcset="https://flowaccountcdn.com/new_landing/icon/MobilePOS.webp" type="image/webp" />
                  <img
                    src="https://flowaccountcdn.com/new_landing/icon/MobilePOS.png"
                    class="MobilePOS-icon"
                    alt="MobilePOS icon"
                    width="20"
                    height="auto"
                  />
                </picture>
                <span style="padding-top: 3px" class="package-textbold-logo"> MobilePOS</span>
              </div>
              <ng-container *ngIf="package.level === packageLevelEnum.Free">
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.FREE.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <span class="mobilepos-first-list">{{
                  'PACKAGE_TABLE.MOBILEPOS.STANDARD.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.STANDARD.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <span class="mobilepos-first-list">{{ 'PACKAGE_TABLE.MOBILEPOS.PRO.ALL_FEATURE' | translate }}</span>
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <span class="mobilepos-first-list">{{
                  'PACKAGE_TABLE.MOBILEPOS.PRO_BUSINESS.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.PRO_BUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <div class="payroll-feature-list desktop">
              <div class="product-name">
                <img
                  src="https://flowaccountcdn.com/new_landing/icon/FP_Logo.png"
                  class="flowpayroll-icon"
                  alt="FlowPayroll icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> Payroll</span>
              </div>
              <ng-container *ngIf="package.level === packageLevelEnum.Free">
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <ng-container *ngFor="let item of loopArray(3); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <span class="payroll-first-list">{{
                  'PACKAGE_TABLE.PAYROLL.PRO_BUSINESS.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(3); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.PRO_BUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <div class="autokey-feature-list desktop">
              <div class="product-name" *ngIf="package.level !== packageLevelEnum.Free">
                <img
                  src="https://flowaccountcdn.com/new_landing/icon/AutoKey_Logo.png"
                  class="autokey-icon"
                  alt="Autokey icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> AutoKey</span>
              </div>

              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <ng-container *ngFor="let item of loopArray(2); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.STANDARD.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <ng-container *ngFor="let item of loopArray(1); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <ng-container *ngFor="let item of loopArray(2); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.PROBUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>

            <!-- tablet -->
            <div
              class="fa-feature-list tablet"
              [ngClass]="{
                active: checkTogglePackageList(package.level) || page === currentPage.Pricing,
                'pro-business': package.level === packageLevelEnum.ProBusiness
              }"
            >
              <div class="product-name">
                <img
                  src="{{ package.application.icon }} "
                  class="fa-logo"
                  loading="lazy"
                  alt="FlowAccount icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> {{ package.application.name }}</span>
              </div>

              <ng-container
                *ngFor="
                  let item of translate.currentLang === 'th' ? package.featureTH.items_1 : package.feature.items_1;
                  let i = index
                "
              >
                <!-- <div class="list-text"
                  ><span class="dot"><i class="fa fa-circle"></i></span> <span class="text">{{ item }}</span>
                </div> -->

                <div class="list-text">
                  <!-- dot ถ้าเป็น packgae: free จะมี dot with text ตั้งแต่ index === 0 
                      dot ถ้าเป็น packgae: !== free จะมี dot with text ตั้งแต่ index > 0 
                  -->
                  <span
                    *ngIf="i !== 0 && package.level !== packageLevelEnum.Free && !checkPackageSubList(package.level, i)"
                    class="dot"
                    ><i class="fa fa-check"></i
                  ></span>

                  <!-- sub list dot -->
                  <span
                    *ngIf="i !== 0 && package.level !== packageLevelEnum.Free && checkPackageSubList(package.level, i)"
                    class="dot"
                    ><i class="fa fa-check"></i
                  ></span>

                  <span *ngIf="package.level === packageLevelEnum.Free" class="dot"><i class="fa fa-check"></i></span>
                  <!-- text  ถ้าเป็น packgae: !== free index === 0  text จะเป็นตัวหนา -->
                  <span *ngIf="package.level === packageLevelEnum.Free" class="text" [innerHtml]="item"></span>
                  <span
                    *ngIf="package.level !== packageLevelEnum.Free && !checkPackageSubList(package.level, i)"
                    [ngClass]="{ 'text-bold': i === 0, text: i !== 0 }"
                    [innerHtml]="item"
                  ></span>

                  <!-- text มี sub list ที่ ProBusiness -->
                  <span *ngIf="checkPackageSubList(package.level, i)" [innerHtml]="item"></span>
                </div>
              </ng-container>
            </div>
            <div
              class="mobilepos-feature-list tablet"
              [ngClass]="{
                active: checkTogglePackageList(package.level) || page === currentPage.Pricing,
                'pro-business': package.level === packageLevelEnum.ProBusiness
              }"
            >
              <div class="product-name">
                <picture>
                  <source srcset="https://flowaccountcdn.com/new_landing/icon/MobilePOS.webp" type="image/webp" />
                  <img
                    src="https://flowaccountcdn.com/new_landing/icon/MobilePOS.png"
                    class="MobilePOS-icon"
                    alt="MobilePOS icon"
                    width="20"
                    height="auto"
                  />
                </picture>

                <span style="padding-top: 3px" class="package-textbold-logo"> MobilePOS</span>
              </div>

              <ng-container *ngIf="package.level === packageLevelEnum.Free">
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.FREE.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <span class="mobilepos-first-list">{{
                  'PACKAGE_TABLE.MOBILEPOS.STANDARD.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.STANDARD.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <span class="mobilepos-first-list">{{ 'PACKAGE_TABLE.MOBILEPOS.PRO.ALL_FEATURE' | translate }}</span>
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <span class="mobilepos-first-list">{{
                  'PACKAGE_TABLE.MOBILEPOS.PRO_BUSINESS.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(5); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.MOBILEPOS.PRO_BUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div
              class="payroll-feature-list tablet"
              [ngClass]="{
                active: checkTogglePackageList(package.level) || page === currentPage.Pricing,
                'pro-business': package.level === packageLevelEnum.ProBusiness
              }"
            >
              <div class="product-name">
                <img
                  src="https://flowaccountcdn.com/new_landing/icon/FP_Logo.png"
                  class="flowpayroll-icon"
                  alt="FlowPayroll icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> Payroll</span>
              </div>

              <ng-container *ngIf="package.level === packageLevelEnum.Free">
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <ng-container *ngFor="let item of loopArray(4); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <ng-container *ngFor="let item of loopArray(3); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>

              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <span class="payroll-first-list">{{
                  'PACKAGE_TABLE.PAYROLL.PRO_BUSINESS.ALL_FEATURE' | translate
                }}</span>
                <ng-container *ngFor="let item of loopArray(3); let i = index">
                  <div class="list-text">
                    <span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.PAYROLL.PRO_BUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
            <div
              class="autokey-feature-list tablet"
              [ngClass]="{
                active: checkTogglePackageList(package.level) || page === currentPage.Pricing,
                'pro-business': package.level === packageLevelEnum.ProBusiness,
                'free-package': package.level === packageLevelEnum.Free
              }"
            >
              <div class="product-name" *ngIf="package.level !== packageLevelEnum.Free">
                <img
                  src="https://flowaccountcdn.com/new_landing/icon/AutoKey_Logo.png"
                  class="autokey-icon"
                  alt="Autokey icon"
                  width="20"
                  height="auto"
                />
                <span class="package-textbold-logo"> AutoKey</span>
              </div>
              <ng-container *ngIf="package.level === packageLevelEnum.Standard">
                <ng-container *ngFor="let item of loopArray(2); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.STANDARD.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="package.level === packageLevelEnum.Pro">
                <ng-container *ngFor="let item of loopArray(1); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.PRO.TEXT_' + (i + 1) | translate"> </span>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="package.level === packageLevelEnum.ProBusiness">
                <ng-container *ngFor="let item of loopArray(2); let i = index">
                  <div class="list-text"
                    ><span class="dot"><i class="fa fa-check"></i></span>
                    <span class="text" [innerHtml]="'PACKAGE_TABLE.AUTOKEY.PROBUSINESS.TEXT_' + (i + 1) | translate">
                    </span>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <!-- Button -->
    <ng-template #packageButton let-package="package" let-button="button">
      <button
        class="btn-package"
        [ngClass]="button.class"
        [attr.data-package-id]="button.dataId"
        [attr.data-package-name]="button.dataName"
        (click)="goToRegister(button.dataId, button.dataName)"
      >
        <span>{{ button.text | translate }}</span>
      </button>
      <ng-container *ngIf="package.level !== packageLevelEnum.Free">
        <div class="package-button__detail">
          <ng-container *ngFor="let detail of packageDetails">
            <div class="package-button__detail--{{ detail.class }}">
              <i class="fa {{ detail.icon }}" style="color: #2898cb">&nbsp;</i
              ><span>{{ detail.text | translate }}</span>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </ng-template>
  </section>

  <section class="pricing-package-container-privilege">
    <div class="topic__link">
      <i class="fas fa-gift"></i>&nbsp;
      <a
        class="hover-underline-text"
        [href]="translate.currentLang === 'th' ? '/privilege' : '/' + translate.currentLang + '/privilege'"
        rel="noopener noreferrer"
        target="_blank"
      >
        <span>{{ 'PRIVILEGE.LINK_TEXT' | translate }}</span></a
      >&nbsp;<i class="fas fa-angle-right"></i>
    </div>
  </section>
  <!-- หนึ่ง: comment section นี้ไปก่อน เพราะ tasks ถัดไปจะเอา beta function beta ในตาราง pricing ออก  -->
  <!-- <section class="beta-text" [ngClass]="{ 'display-only-desktop': page === currentPage.Home }">
    <div class="desktop" [innerHtml]="'PACKAGE_TABLE.BETA_TEXT.DESKTOP' | translate"> </div>
    <div class="tablet" [innerHtml]="'PACKAGE_TABLE.BETA_TEXT.TABLET' | translate"> </div>
  </section> -->

  <!-- <section class="contact-support" [ngClass]="{ 'custom-margin-mobile': page === currentPage.Home }">
    <div class="text-wrapper"
      ><i class="fas fa-headset"></i>
      <span class="desktop" [innerHtml]="'PACKAGE_TABLE.CONTACT_SUPPORT.TEXT' | translate"></span>
      <span class="mobile" [innerHtml]="'PACKAGE_TABLE.CONTACT_SUPPORT.TEXT_MOBILE' | translate"></span>
    </div>
  </section> -->
</div>
